import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <>
      {/* Topbar Start */}
      <div className="container-fluid bg-dark px-5 d-none d-lg-block">
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              <small className="me-3 text-light">
                <i className="fa fa-map-marker-alt me-2"></i>123 Street, New
                York, USA
              </small>
              <small className="me-3 text-light">
                <i className="fa fa-phone-alt me-2"></i>+012 345 6789
              </small>
              <small className="text-light">
                <i className="fa fa-envelope-open me-2"></i>info@example.com
              </small>
            </div>
          </div>

          <div className="col-lg-4 text-center text-lg-end">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              <Link
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                to="#"
              >
                <i className="fab fa-twitter fw-normal"></i>
              </Link>

              <Link
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                to="#"
              >
                <i className="fab fa-facebook-f fw-normal"></i>
              </Link>

              <Link
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                to="#"
              >
                <i className="fab fa-linkedin-in fw-normal"></i>
              </Link>

              <Link
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                to="#"
              >
                <i className="fab fa-instagram fw-normal"></i>
              </Link>

              <Link
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle"
                to="#"
              >
                <i className="fab fa-youtube fw-normal"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Topbar End */}

      {/* Navbar Start */}
      <div className="container-fluid position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0 sticky-top shadow-sm">
          <Link to="/" className="navbar-brand d-flex align-items-center p-0">
            <img
              src="assets/img/mympp.png"
              alt="Logo"
              height="50"
              className="me-2"
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link to="/" className="nav-item nav-link">
                Home
              </Link>

              <Link to="/about" className="nav-item nav-link">
                About
              </Link>

              <Link to="/services" className="nav-item nav-link">
                Services
              </Link>

              <Link to="/contact" className="nav-item nav-link">
                Contact
              </Link>
            </div>
          </div>
        </nav>
      </div>
      {/* Navbar End */}
    </>
  );
}
